module.exports = "./img/6d2d9111b755ed5f0849857c9a6ce191.png";